import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from '@modules/error/error.component';
import { InitComponent } from '@modules/init/init.component';
import { ProcessComponent } from '@modules/process/process.component';
import { RedirectToExternalBankComponent } from '@modules/redirect-to-external-bank/redirect-to-external-bank.component';
import { WebauthPopupComponent } from '@modules/webauth-popup/webauth-popup.component';

const routes: Routes = [
  {
    path: 'init/:userId',
    component: InitComponent,
    pathMatch: 'full',
  },
  {
    path: 'process',
    component: ProcessComponent,
    pathMatch: 'full',
  },
  {
    path: 'webauth',
    component: WebauthPopupComponent,
    pathMatch: 'full',
  },
  {
    path: 'redirect-to-external-bank',
    component: RedirectToExternalBankComponent,
    pathMatch: 'full',
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: '**',
    redirectTo: '/error',
  },
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
